import { render, staticRenderFns } from "./LightSwitch.vue?vue&type=template&id=3506230a&scoped=true&"
import script from "./LightSwitch.vue?vue&type=script&lang=ts&"
export * from "./LightSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LightSwitch.vue?vue&type=style&index=0&id=3506230a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506230a",
  null
  
)

export default component.exports